class ManualPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default ManualPermissions
